import Booking from '@solvhealth/types/interfaces/Booking';
import Location from '@solvhealth/types/interfaces/Location';
import React, { Component } from 'react';
import styled from 'styled-components';
import ReviewHeader from '~/components/AddReview/ReviewHeader';
import { colors } from '../../../constants/colors';
import {
  ADD_REVIEW_TO_SOLV,
  ADD_REVIEW_UNGATED_REVIEW_ON_GOOGLE_OR_SOLV,
  DO_YOU_HAVE_GOOGLE_ACCOUNT,
} from '../../../constants/index';
import { fontFamily, fontSize } from '../../../constants/text';
import {
  ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE,
  ADD_REVIEW_NO_GOOGLE_ACCOUNT,
} from '../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../core/analytics/index';
import FlowTransition from '../transitions/FlowTransition';
import { goToGoogleReviewFlow } from '~/core/dapi/tracking';
const FIVE_STAR = 5;

const ErrorContainer = styled.div.withConfig({ componentId: 'sc-oubzmf-0' })`
  position: relative;
`;

const ErrorMessage = styled.div.withConfig({ componentId: 'sc-oubzmf-1' })`
  position: absolute;
  display: flex;
  text-align: left;
  background: ${colors.fadeToBlack};
  color: ${colors.theWhiteAlbum};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  padding: 20px;
  overflow: hidden;
  animation: pop-down 500ms ease;
`;

const ErrorImage = styled.img.withConfig({ componentId: 'sc-oubzmf-2' })`
  width: 20px;
  height: 20px;
  padding: 0 20px 0 0;
  margin: auto;
`;

const LeaveReviewCopy = styled.div.withConfig({ componentId: 'sc-oubzmf-3' })`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.extraLarge};
  line-height: 36px;
  margin-top: 50px;
`;

const DescriptionCopy = styled.div.withConfig({ componentId: 'sc-oubzmf-4' })`
  color: ${colors.lanaDelGrey};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.medium};
  line-height: 30px;
  margin: 20px auto;
`;

const WhiteButton = styled.div.withConfig({ componentId: 'sc-oubzmf-5' })`
  cursor: pointer;
  width: 60%;
  border-radius: 35px;
  padding: 10px 20px;
  background-color: ${colors.theWhiteAlbum};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.35);
  color: ${colors.mrBlueSky};
  font-size: ${fontSize.medium};
  margin: 40px auto 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const GoogleLogo = styled.img.withConfig({ componentId: 'sc-oubzmf-6' })`
  margin: 2px 0 0 5px;
  width: 70px;
`;

const FooterLink = styled.a.withConfig({ componentId: 'sc-oubzmf-7' })`
  cursor: pointer;
`;

type Props = {
  bookingId: string;
  booking: Booking;
  location: Location;
  handleRatingChange?: (...args: any[]) => any;
  setFlowState?: (...args: any[]) => any;
  review?: string;
  error?: any;
  flowState: string;
  googleUrl?: string;
  isSubmitting?: boolean;
  starRating?: number;
  hasRecommendedClinic?: boolean;
  submitReview?: (...args: any[]) => any;
  leaveAReview?: any;
};

class ReviewOnGoogleOrSolv extends Component<Props> {
  getTrackingProperties = () => ({
    locationId: this.props.location.id,
    flowType: ADD_REVIEW_UNGATED_REVIEW_ON_GOOGLE_OR_SOLV,
    starRating: this.props.starRating,
    review: this.props.review,
    bookingId: this.props.bookingId,
  });

  handleReviewOnGoogle = () => {
    analyticsTrackEvent(ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE, this.getTrackingProperties());

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: this.props.leaveAReview['primary rating'],
        hasRecommendedClinic: this.props.hasRecommendedClinic,
        hasClickedReviewOnGoogle: true,
      },
      false
    );

    goToGoogleReviewFlow(this.props.googleUrl as string, this.props.bookingId);
    return null;
  };

  handleReviewOnSolv = () => {
    analyticsTrackEvent(ADD_REVIEW_NO_GOOGLE_ACCOUNT, this.getTrackingProperties());

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: this.props.leaveAReview['primary rating'],
        hasRecommendedClinic: this.props.hasRecommendedClinic,
        hasClickedReviewOnGoogle: false,
      },
      false
    );

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.handleRatingChange(FIVE_STAR);

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.setFlowState(ADD_REVIEW_TO_SOLV);
  };

  renderReviewOnGoogleOrSolv = () => (
    <>
      <ReviewHeader booking={this.props.booking} location={this.props.location} />
      {this.props.error && (
        <ErrorContainer>
          <ErrorMessage>
            <ErrorImage src="/images/icons/alert_yellow.svg" />
            {this.props.booking?.ratingDate &&
              "Looks like you've already submitted a review for this booking. If you submit another review, it will replace your old one!"}
            {this.props.error && 'Whoops! Something went wrong. Try again later.'}
          </ErrorMessage>
        </ErrorContainer>
      )}

      <LeaveReviewCopy>Please leave a review!</LeaveReviewCopy>

      <DescriptionCopy>
        If you have a Gmail account, <br />
        we'd appreciate a quick review!
      </DescriptionCopy>

      <WhiteButton onClick={this.handleReviewOnGoogle}>
        Review us on
        <GoogleLogo alt="google-logo" src="/images/icons/google_logo_color.svg" />
      </WhiteButton>

      <DescriptionCopy>
        If not, please leave a review on: <br />
        <FooterLink onClick={this.handleReviewOnSolv}>solvhealth.com</FooterLink>
      </DescriptionCopy>
    </>
  );

  render() {
    return (
      <FlowTransition
        flowState={this.props.flowState}
        stateToActivateFlow={DO_YOU_HAVE_GOOGLE_ACCOUNT}
        toRender={this.renderReviewOnGoogleOrSolv}
      />
    );
  }
}

export default ReviewOnGoogleOrSolv;
